import { render, staticRenderFns } from "./MyOrdersTable.vue?vue&type=template&id=37c64b79"
import script from "./MyOrdersTable.vue?vue&type=script&lang=js"
export * from "./MyOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports